import _ from 'lodash';
import { Record as record } from 'immutable';

import { SeatingPrefs, JourneyDirections } from '../constants/AppConstants';
import { construct, resolve } from '../helpers/LinkMapper';


const defaults = {
    inward: false,
    outward: false,
    direction: SeatingPrefs.NONE,
    position: SeatingPrefs.NONE,
    seatType: SeatingPrefs.NONE,
    quietCoach: false,
    nearToilets: false,
    powerSocket: false,
    nearLuggageRack: false
};


class SeatingPreferences extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(SeatingPreferences, json, {
            inward: resolve.with(Boolean),
            outward: resolve.with(Boolean),
            direction: resolve.with(String),
            position: resolve.with(String),
            seatType: resolve.with(String),
            quietCoach: resolve.with(Boolean),
            nearToilets: resolve.with(Boolean),
            powerSocket: resolve.with(Boolean),
            nearLuggageRack: resolve.with(Boolean)
        });
    }

    shouldReserve () {
        return this.get('inward') || this.get('outward');
    }

    shouldReserveDirection (direction) {
        return {
            [ JourneyDirections.OUTWARD ]: this.get('outward'),
            [ JourneyDirections.INWARD ]: this.get('inward')
        }[direction];
    }

    toCommonCodes() {
        let codes = [this.direction, this.position, this.seatType];
        if (this.quietCoach) { codes.push(SeatingPrefs.QUIET_COACH); }
        if (this.nearToilets) { codes.push(SeatingPrefs.NEAR_TOILET); }
        if (this.powerSocket) { codes.push(SeatingPrefs.POWER_SOCKET); }
        if (this.nearLuggageRack) { codes.push(SeatingPrefs.NEAR_LUGGAGE); }
        return codes;
    }

    toCodes() {
        return this.shouldReserve() ? this.toCommonCodes() : null;
    }

    toReservationCodes() {
        return this.toCommonCodes();
    }

    hasPreferences () {
        const before = _.omit(defaults, ['inward', 'outward']);
        const after = _.omit(this.toJS(), ['inward', 'outward']);
        return !_.isEqual(before, after);
    }

    resetPreferences () {
        return this.merge(defaults);
    }
}

export default SeatingPreferences;
